import { render, staticRenderFns } from "./RequestProcedureHistory.vue?vue&type=template&id=1dd35d1b&scoped=true"
import script from "./RequestProcedureHistory.vue?vue&type=script&lang=js"
export * from "./RequestProcedureHistory.vue?vue&type=script&lang=js"
import style0 from "./RequestProcedureHistory.vue?vue&type=style&index=0&id=1dd35d1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd35d1b",
  null
  
)

export default component.exports